import React from 'react';
import PropTypes from 'prop-types';

/**
 * CarouselControls - Dots navigation for the hero carousel
 */
const CarouselControls = ({
  total,
  current,
  onDotClick
}) => {
  if (total <= 1) {
    return null;
  }

  return (
    <div
      role="tablist"
      aria-label="Carousel slides"
      style={{
        position: 'absolute',
        right: '8px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0',
        paddingRight: '20px',
        height: 'auto',
        overflow: 'visible',
        zIndex: 10
      }}
    >
      {Array.from({ length: total }).map((_, index) => (
        <button
          type="button"
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          role="tab"
          aria-selected={index === current}
          aria-label={`Go to slide ${index + 1}`}
          onClick={() => onDotClick(index)}
          style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: index === current ? 'var(--Colors-Global-Accent-Var, #EFFF00)' : '#FFFFFF',
            marginBottom: '8px',
            padding: '0',
            zIndex: 1000,
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0px 3px 10px 3px #00000030'
          }}
          onMouseEnter={(e) => {
            if (index !== current) {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
            }
          }}
          onMouseLeave={(e) => {
            if (index !== current) {
              e.target.style.backgroundColor = '#FFFFFF';
            }
          }}
        />
      ))}
    </div>
  );
};

CarouselControls.propTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  onDotClick: PropTypes.func.isRequired
};

export default CarouselControls;
